$(function() {
  if ($('body.collages.show').length < 1) return

  // product-view
  const { apiGatewayUrl, apiGatewayApiKey, siteId, userId, collageId, productCodes } = window.gon
  App.util.sendProductView({
    apiGatewayUrl, apiGatewayApiKey, siteId, userId, productCodes, collageId,
  })
})
